// Drag-to-scroll for elements with draggable="true"
(function() {
  const init = (el) => {
    if (el.dataset.dragScroll) return;
    el.dataset.dragScroll = 'true';
    el.style.cursor = 'grab';
    let isDown = false, startX, scrollLeft;
    
    el.ondragstart = (e) => e.preventDefault();

    el.addEventListener('wheel', (e) => {
      // Don't prevent default - allow normal scrolling
      el.scrollLeft += e.deltaY;
    }, { passive: true });
    
    el.onmousedown = (e) => {
      isDown = true;
      el.style.cursor = 'grabbing';
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    };
    el.onmouseup = el.onmouseleave = () => {
      isDown = false;
      el.style.cursor = 'grab';
    };
    el.onmousemove = (e) => {
      if (!isDown) return;
      e.preventDefault(); // Prevent text selection while dragging
      el.scrollLeft = scrollLeft - (e.pageX - el.offsetLeft - startX) * 2;
    };
  };

  const setup = () => document.querySelectorAll('[draggable="true"]').forEach(init);
  
  (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', setup) : setup)();
  
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(() => drawer.classList.contains('active') && setTimeout(setup, 100)).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
})();

// Shipping and total calculation
class CartShippingTotal extends HTMLElement {
  connectedCallback() {
    this.update();
    if (typeof subscribe !== 'undefined' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(() => this.update(), 100));
    }
    const subtotalEl = this.querySelector('[data-subtotal-value]');
    if (subtotalEl) {
      new MutationObserver(() => this.update()).observe(subtotalEl, { childList: true, characterData: true });
    }
  }

  parseValue(str) {
    if (!str) return 0;
    const numStr = str.replace(/[^\d.,]/g, '');
    const hasComma = str.includes(',');
    if (hasComma) {
      return parseFloat(numStr.replace(/\./g, '').replace(',', '.')) || 0;
    }
    return parseFloat(numStr.replace(/,/g, '')) || 0;
  }

  formatValue(amount, template) {
    // Extract currency symbol/code from template (e.g., "kr", "DKK", "$", "€")
    const currencyMatch = template.match(/([A-Z]{3}|kr|€|\$|£|¥|R\$)/);
    const currency = currencyMatch ? currencyMatch[1] : '';
    const hasComma = template.includes(',');
    const currencyBefore = /^[^\d]/.test(template);
    
    // Format number matching template format
    let formatted = amount.toFixed(2);
    if (hasComma) {
      formatted = formatted.replace('.', ',');
      if (amount >= 1000) {
        const parts = formatted.split(',');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        formatted = parts.join(',');
      }
    } else {
      if (amount >= 1000) {
        const parts = formatted.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        formatted = parts.join('.');
      }
    }
    
    // Match currency position from template
    return currencyBefore ? `${currency}${formatted}` : `${formatted} ${currency}`;
  }

  update() {
    if (!window.shippingSettings) return;
    const subtotalEl = this.querySelector('[data-subtotal-value]');
    const shippingEl = this.querySelector('[data-shipping-display]');
    const totalEl = this.querySelector('[data-total-display]');
    if (!subtotalEl || !shippingEl || !totalEl) return;

    const subtotalText = subtotalEl.textContent.trim();
    const subtotal = this.parseValue(subtotalText);
    const {
      limit: rawLimit,
      price: rawPrice,
      shippingFreeLabel,
      shippingCalculatedEnabled,
      shippingCalculatedText
    } = window.shippingSettings;
    const limit = rawLimit === null || rawLimit === '' ? null : Number(rawLimit);
    const price = rawPrice === null || rawPrice === '' ? null : Number(rawPrice);
    const hasLimit = Number.isFinite(limit) && limit > 0;
    const hasPrice = Number.isFinite(price) && price > 0;
    const calculatedLabel = shippingCalculatedText;

    if (!hasLimit || !hasPrice) {
      shippingEl.textContent = shippingCalculatedEnabled ? calculatedLabel : '';
      totalEl.textContent = this.formatValue(subtotal, subtotalText);
      return;
    }

    // If calculated shipping is enabled, always show calculated text instead of price
    if (shippingCalculatedEnabled) {
      shippingEl.textContent = calculatedLabel;
      totalEl.textContent = this.formatValue(subtotal, subtotalText);
      return;
    }

    const isFree = subtotal >= limit;
    const total = subtotal + (isFree ? 0 : price);

    shippingEl.textContent = isFree ? (shippingFreeLabel || calculatedLabel) : this.formatValue(price, subtotalText);
    totalEl.textContent = this.formatValue(total, subtotalText);
  }
}

customElements.define('cart-shipping-total', CartShippingTotal);

// Gift wrapping functionality
class CartGiftWrapping extends HTMLElement {
  constructor() {
    super();
    this.giftWrappingItems = [];
    this.init();
  }

  async init() {
    await this.checkCart();
    this.setupListeners();
  }

  async checkCart() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      this.giftWrappingItems = cart.items.filter(item => item.properties?._gift_wrapping === 'true');
      this.updateUI();
    } catch (error) {
      console.error('Error checking cart:', error);
    }
  }

  updateUI() {
    // Update all options based on cart state
    this.querySelectorAll('.gift-wrapping-option__input').forEach(input => {
      const variantId = parseInt(input.dataset.variantId);
      const isSelected = this.giftWrappingItems.some(item => item.variant_id === variantId);
      const option = input.closest('.gift-wrapping-option');
      const button = option?.querySelector('.gift-wrapping-option__button');
      
      input.checked = isSelected;
      option?.classList.toggle('is-selected', isSelected);
      
      if (button && !button.disabled) {
        this.updateButtonState(button, isSelected, false);
      }
    });
  }

  updateButtonState(button, isSelected, isLoading) {
    const spinner = button.querySelector('.loading-overlay__spinner');
    const labelSpan = button.querySelector('.label-text');
    
    if (!labelSpan) return;
    
    // Show/hide spinner
    if (spinner) {
      spinner.classList.toggle('hidden', !isLoading);
    }
    
    // Update text - ALWAYS keep text visible
    if (isLoading && !isSelected) {
      // When adding: show "Add to cart" text with spinner (BOTH visible)
      labelSpan.textContent = window.giftWrappingStrings?.addToCart || 'Add to cart';
    } else if (isLoading && isSelected) {
      // When removing: show "Remove" text with spinner (BOTH visible)
      labelSpan.textContent = window.giftWrappingStrings?.remove || 'Remove';
    } else {
      // When not loading: show appropriate text based on selection
      labelSpan.textContent = isSelected 
        ? (window.giftWrappingStrings?.remove || 'Remove')
        : (window.giftWrappingStrings?.addToCart || 'Add to cart');
    }
    
    // Always keep text visible
    labelSpan.style.display = '';
    
    button.disabled = isLoading;
  }

  setupListeners() {
    this.querySelectorAll('.gift-wrapping-option__button').forEach(button => {
      button.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const option = button.closest('.gift-wrapping-option');
        const input = option?.querySelector('.gift-wrapping-option__input');
        if (!input || button.disabled) return;
        
        const variantId = parseInt(button.dataset.variantId);
        const isSelected = input.checked;
        
        if (isSelected) {
          // Remove from cart
          this.updateButtonState(button, true, true);
          input.checked = false;
          option.classList.remove('is-selected');
          await this.removeFromCart(variantId);
          await this.checkCart();
          this.updateButtonState(button, false, false);
        } else {
          // Add to cart - show "Add to cart" text with spinner
          this.updateButtonState(button, false, true);
          input.checked = true;
          option.classList.add('is-selected');
          
          // Uncheck other options and update their buttons
          this.querySelectorAll('.gift-wrapping-option__input').forEach(otherInput => {
            if (otherInput !== input) {
              otherInput.checked = false;
              const otherOption = otherInput.closest('.gift-wrapping-option');
              otherOption?.classList.remove('is-selected');
              const otherButton = otherOption?.querySelector('.gift-wrapping-option__button');
              if (otherButton && !otherButton.disabled) {
                this.updateButtonState(otherButton, false, false);
              }
            }
          });
          
          await this.addToCart(variantId);
          await this.checkCart();
          // After item is added: hide spinner and "add to cart" text, show "remove"
          this.updateButtonState(button, true, false);
        }
      });
    });
    
    // Listen for external cart updates
    if (typeof subscribe !== 'undefined' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(() => this.checkCart(), 100));
    }
  }

  async addToCart(variantId) {
    await this.removeAll();
    
    const config = typeof fetchConfig !== 'undefined' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('properties[_gift_wrapping]', 'true');
    
    const cartItems = document.querySelector('cart-drawer-items');
    if (cartItems?.getSectionsToRender) {
      formData.append('sections', cartItems.getSectionsToRender().map(s => s.section).join(','));
      formData.append('sections_url', window.location.pathname);
    }
    
    config.body = formData;
    const url = typeof routes !== 'undefined' && routes.cart_add_url ? routes.cart_add_url : '/cart/add.js';
    
    try {
      const state = await (await fetch(url, config)).json();
      if (state.status) {
        console.error('Error:', state.description);
        this.updateUI(false);
        return;
      }
      
      if (state.sections) {
        const cartDrawer = document.querySelector('cart-drawer');
        const sections = cartItems?.getSectionsToRender() || cartDrawer?.getSectionsToRender() || [];
        sections.forEach(section => {
          if (state.sections[section.section]) {
            const el = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
            const html = cartDrawer?.getSectionInnerHTML(state.sections[section.section], section.selector);
            if (html && el) el.innerHTML = html;
          }
        });
      }
      
      if (typeof publish !== 'undefined' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate);
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.updateUI(false);
    }
  }

  async removeFromCart(variantId) {
    let item = this.giftWrappingItems.find(item => item.variant_id === variantId);
    if (!item) {
      await this.checkCart();
      item = this.giftWrappingItems.find(item => item.variant_id === variantId);
      if (!item) return;
    }
    
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
      
      if (!response.ok) {
        throw new Error('Failed to remove item from cart');
      }
      
      // Refresh cart drawer sections
      const cartDrawer = document.querySelector('cart-drawer');
      const cartItems = document.querySelector('cart-drawer-items');
      
      if (cartDrawer && cartItems?.getSectionsToRender) {
        const sections = cartItems.getSectionsToRender().map(s => s.section).join(',');
        const sectionsResponse = await fetch(`${window.location.pathname}?sections=${sections}`);
        const sectionsData = await sectionsResponse.json();
        
        cartItems.getSectionsToRender().forEach(section => {
          if (sectionsData[section.section]) {
            const el = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
            const html = cartDrawer.getSectionInnerHTML(sectionsData[section.section], section.selector);
            if (html && el) el.innerHTML = html;
          }
        });
      }
      
      if (typeof publish !== 'undefined' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate);
      }
    } catch (error) {
      console.error('Error removing from cart:', error);
      this.updateUI(false);
    }
  }

  async removeAll() {
    if (this.giftWrappingItems.length === 0) return;
    
    await Promise.all(this.giftWrappingItems.map(item => 
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      })
    ));
    
    this.giftWrappingItems = [];
    
    if (typeof publish !== 'undefined' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate);
    }
  }
}

customElements.define('cart-gift-wrapping', CartGiftWrapping);

// Cart recommendation size selector
(function() {
  const handleSizeChange = (select) => {
    const variantId = select.value;
    const formId = select.dataset.formId;
    const form = document.getElementById(formId);
    
    if (form) {
      const variantInput = form.querySelector('.product-variant-id');
      if (variantInput) {
        variantInput.value = variantId;
      }
    }
  };

  const setupSizeSelectors = () => {
    document.querySelectorAll('.cart-recommendation-size-select').forEach(select => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => handleSizeChange(select));
    });
  };

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupSizeSelectors);
  } else {
    setupSizeSelectors();
  }

  // Re-initialize when cart drawer content updates
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(() => {
      if (drawer.classList.contains('active')) {
        setTimeout(setupSizeSelectors, 100);
      }
    }).observe(drawer, { 
      attributes: true, 
      attributeFilter: ['class'], 
      childList: true, 
      subtree: true 
    });
  }
})();

